/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, ReactElement } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { dataService2 } from '../utils/helpers/view/detailsHelper';
import Error from '../components/common/ErrorMessage';
import { createGlobalStyle } from 'styled-components';
import { dataStatColumnsHydroDetail } from '../utils/helpers/table/tableHelper';
import MaterialTableComponent from '../components/module/table/materialTableComponent';

const HydroDetail = (props: any) => {
  // variables
  const [lastError, setError] = useState<boolean>(false);

  //observer store
  dataService2.getError().subscribe((errorState: any) => {
    setError(errorState);
  });

  //Table de réponse des filtres
  const renderTable = (): ReactElement => {
    const createRows = () => {
      let datas: any[] = [];
      props.data.forEach((line: any, index: number) => {
        let year =
          new Date().getFullYear() - line['attributes'].YearFromCurrentYear;
        let yearRow = new Date().getFullYear() - props.row.year;
        if (
          year === yearRow &&
          props.row.type === line['attributes'].WorkTypeGroup
        ) {
          datas.push({
            id: index,
            nature: line['attributes'].WorkTypeLabel,
            type: line['attributes'].WorkTypeGroup,
            effectif: line['attributes'].CountByYear,
          });
        }
      });
      return datas;
    };

    return (
      <Container className='hydroDetail-parameterClass'>
        <Styles />
        <Container className='hydroDetailContentContainer'>
          <Container className='hydroDetailContainer'>
            <MaterialTableComponent
              columns={dataStatColumnsHydroDetail}
              rows={createRows()}
              rowsPerPage={10}
            />
          </Container>
        </Container>
      </Container>
    );
  };

  return (
    <>
      {lastError ? <Error IsVisible={lastError}></Error> : null}
      <Styles />
      <div style={{ textAlign: 'center' }}>
        <Word
          textStyle='title'
          automatedTestId='global-pr-name'
          variant='h1'
          value={props.row.label}
        />
      </div>
      <Card automatedTestId='indus-table-id'>{renderTable()}</Card>
    </>
  );
};

export const Styles = createGlobalStyle`

.sds-reset-style{
  .sds-container.generalContainer{
    flex-direction:row;
    }
  .global-pr-container{
    .global-pr-content{
      margin-left: 50px;
    }
    margin-left: auto;
    margin-right: auto;
    height:30vh;
    flex-direction:row;
  .pompe-info{
    flex-direction: row;
    margin-bottom: 10px;
    .warning{
      flex-direction: row; 
    }
    #warning-text{
      margin-left:5px;
      color:#FE3123
    }
    .warning-logo{
      margin-left:20px;
    }
    #pompe-derniere-remontee{
     margin-left: 16px;
     margin-right: 5px;
    }
    #pompe-q{
     margin-right: 5px;
    }
  }
  .sds-container.sds-m-card.global-data-pr-container{
    overflow: unset;
    width: 90vw;
    }

  #global-data-pr-container{
    padding: 0 2vw;
    width: 90vw;
    }

 #pompe1,#pompe2,#pompe3,#pompe4{
   margin-bottom: 2vw;
   margin-top: 2vw
    }
 #global-pr-name{
   margin-bottom: 2vw;
   margin-top: 1vw;
    }
  .text-right{
   align-self: flex-end;
   text-decoration: underline;
   margin-left: 75px;
   /* height: 100%; */
   height: 2.5em; /* hauteur du parent */
    }
  }
  .pluvio-text-right{
   align-self: flex-end;
   margin-bottom: 50px;
   flex-direction: row;   
   margin-right: 10px;

  }
  .global-data-header{
    flex-direction: row;
    /* width: fit-content; */
    height: 53px;
    width: 100%;
  }
  #pluvio-switch{
      margin-right: 15px;
      vertical-align: middle;
    }
}

`;
export default HydroDetail;
